import Constants from "../../Constants";
import Api from "../../Api";

export class Neo4jExportApiClient {

    private static readonly NEO4J_API_BASE_URL: string = Constants.API_HOST + "/rest-api/neo4j";

    exportModelToNeo4j(): Promise<void> {
        const request = {
            url: `${Neo4jExportApiClient.NEO4J_API_BASE_URL}/export`,
            method: "POST",
        };
        return Api.createAjax(request)
            .toPromise()
            .then(() => undefined);
    }
}

const neo4jExportApiClient = new Neo4jExportApiClient();
export default neo4jExportApiClient;
